import React, {useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import moment from "moment";
import __ from "lodash";
import {Grid, InputLabel} from "@material-ui/core";

import ChromeTabs from "../../../../controls/ChromeTabs";
import {FormDialog, Text }from "../../../../controls";
import ServicesEditor from "./ServicesEditor";
import Validator from "../../validators/EditServicesValidator";

import { fetch as fetchAirportServiceTypes } from "../../../../services/settings/useAirportServiceTypes";

const buildDefaultOutboundServices = async (record, queryClient) => {
  if (!__.has(record, 'services')) record["services"] = {outbound:[], inbound:[]};
  const outboundServices = await fetchAirportServiceTypes({queryClient, extraKeys: [record.originAirportCode, 'OUT'], useCache: false});
  if (outboundServices && Array.isArray(outboundServices) && outboundServices.length > 0) {
    for (let i = 0; i < outboundServices.length; i++) {
      const outboundService = outboundServices[i];
      if (outboundService.companySpecific) continue;
      if (!__.find(record.services['outbound'], {serviceCode: outboundService.serviceCode})) {
        record.services['outbound'].push({
          ...__.pick(outboundService, ['servicesTypeUuid', 'requiredDefault', 'serviceCode', 'serviceName', 'optional', 'companyType']),              
          isRequired: outboundService.requiredDefault,
          serviceProviderUuid: outboundService.requiredDefault?outboundService.companyUuid:null,
          serviceNotes: ""
        });
      }
    }
  }
}
const buildDefaultInboundServices = async (record, queryClient) => {
  if (!__.has(record, 'services')) record["services"] = {outbound:[], inbound:[]};
  const inboundServices = await fetchAirportServiceTypes({queryClient, extraKeys: [record.destinationAirportCode, 'IN'], useCache: false});
  if (inboundServices && Array.isArray(inboundServices) && inboundServices.length > 0) {
    for (let i = 0; i < inboundServices.length; i++) {
      const inboundService = inboundServices[i];
      if (inboundService.companySpecific) continue;
      if (!__.find(record.services['inbound'], {serviceCode: inboundService.serviceCode})) {
        record.services['inbound'].push({
          ...__.pick(inboundService, ['servicesTypeUuid', 'requiredDefault', 'serviceCode', 'serviceName', 'optional', 'companyType']),              
          isRequired: inboundService.requiredDefault,
          serviceProviderUuid: inboundService.requiredDefault?inboundService.companyUuid:null,
          serviceNotes: ""
        });
      }
    }
  }

}


const EditScheduledServicesDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const SystemData = props.systemData;
  const extraKeys = props.extraKeys;
  const handleUpdate = props.handleUpdateFlight
  const classes = props.classes;

  const eventBus = SystemData.eventBus;

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    scheduledTrip:{},
    record: {},
    title: 'Edit Services',
    skeletonServices: null,
    skeletonSubServices: null,
    extraKeys: extraKeys,
    tabs: [],
    currentTab: ""
  });

  const dateFormat = "DD/MM/YYYY";

  const queryClient = useQueryClient();

  useEffect(()=> {
    const open = async (params) => {
      const {record, scheduledTrip, updateKeys} = params||{};
      const title = `Edit Services for ${record.airlineCode}${record.flightNo}`;

      await buildDefaultOutboundServices(record, queryClient);
      await buildDefaultInboundServices(record, queryClient);

      const tabs =
        [
          {label: `${record.originAirportCode} Outbound`, value: record.originAirportCode},
          {label: `${record.destinationAirportCode} Inbound`, value: record.destinationAirportCode},
        ];
      const currentTab = record.originAirportCode;
      setDialogStates(
        {
          ...dialogStates,
          showDialog:true,
          // skeletonServices: skeletonServices,
          extraKeys: updateKeys||extraKeys,
          record,
          tabs,
          currentTab,
          title,
          scheduledTrip
        }
      );
    }

    eventBus.bind("EditScheduledServicesDialog.open", open);

    return () => {
      eventBus.unbind("EditScheduledServicesDialog.open", open);
    }
  }, [dialogStates, eventBus, extraKeys, queryClient]);



  const handleTabChange = (event, tab) => {
    setDialogStates({...dialogStates, currentTab: tab});
  }

  const handleAddFunction = () => {
    if (eventBus) {
      eventBus.trigger('Services.AddFunction');
    }
  }

  const handleServicesChanged = (changes, props) => {
    const {record, recordChange} = props;
    if (changes && changes.record) {
      const services =  changes.record.services;
      record['services'] = services;
      recordChange({...record, services, servicesChanged: true});

      if (changes.resolve) {
        changes.resolve();
      }
    }
  }

  if (dialogStates.showDialog) {
    return (
      <FormDialog
        title={dialogStates.title}
        message=""
        open={dialogStates.showDialog}
        record={__.cloneDeep(dialogStates.record)}
        dialogOptions={{width: 700, maxWidth: 700, height: 700}}
        classes={classes}
        validator={Validator}
        buttons = {{
          // addFunction: {icon: "add_circle", key: "Add Function", label: "Add Function", color: "primary"},
          save:{icon: "check_circle", key: "Update", label: "Update", color: "primary", disabled: (status)=>{
            if (status.buttonState && status.buttonState.disabled) return true;
            return status.error;
          }},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            handleUpdate.mutate({
              extraKeys: dialogStates.extraKeys,
              record,
              postSuccess: () => {
                setDialogStates({...dialogStates, showDialog: false, record: null});
                if (props.afterSave) {
                  props.afterSave();
                }
              },
              postError: (data) => {
                if (props.onError) {
                  props.onError(data);
                } else if (data.errorMessage) {
                  SystemData.alert("Error", `${data.errorMessage}`);
                } else {
                  SystemData.alert("Error", `An Unexpected Error has occurred.`);
                }
              }
            });
          } else if (state.buttonPressed === "addFunction") {
            handleAddFunction();
          } else {
            setDialogStates({...dialogStates, showDialog: false, record: null});
          }
        }}

      >
        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Flight Number
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${record.airlineCode}-${record.flightNo}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Start Date
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${moment(dialogStates.scheduledTrip.startDate, "YYYY-MM-DD HH:mm:ss").format(dateFormat)}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  End Date
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${moment(dialogStates.scheduledTrip.endDate, "YYYY-MM-DD HH:mm:ss").format(dateFormat)}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Trip Number
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${dialogStates.scheduledTrip.tripPrefix || process.env.REACT_APP_TRIP_PREFIX || 'MAG'} ${(''+dialogStates.scheduledTrip.tripNo||'').padStart(2,'0')}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={6} checkChildren={true}>
            {(record, changeRecord) => (
              <div className="d-flex flex-row justify-content-between align-items-center">
                <InputLabel shrink>
                  Route
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${record.originAirportCode} -> ${record.destinationAirportCode}`}
                />
              </div>
            )}
          </Grid>
        </Grid>

        <Grid item xs={12} checkChildren={false}>
          <ChromeTabs
            id={"AirportTabs"}
            //style={{ alignSelf: "flex-end", display: "inline-block", align: "left" }}
            style={{marginTop: 10}}
            tabs={dialogStates.tabs}
            tabStyle={{
              bgColor: "#ffffff",
              selectedBgColor: "#E6E8EB",
              color: "rgba(0,0,0,0.87)",
            }}
            tabProps={{disableRipple: false}}
            value={dialogStates.currentTab}
            onChange={handleTabChange}
          />
        </Grid>
        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={12} checkChildren={true}>
            {(record, changeRecord, changeButtonState) => (
              <ServicesEditor
                type="SCHEDULED"
                flightRecord={record}
                skeletonServices={dialogStates.skeletonServices}
                outboundAirport={dialogStates.currentTab===record.originAirportCode}
                handleUpdate={handleUpdate}
                canEdit={true}
                classes={classes}
                onChange={handleServicesChanged}
                changeButtonState={changeButtonState}
              />
            )}
            </Grid>
        </Grid>
      </FormDialog>
    )
  }
  return (<></>);
}

export default EditScheduledServicesDialog;

export {buildDefaultOutboundServices, buildDefaultInboundServices}
